(function($) {

	var bufferPoolsValidator = null;
	
	$(document).ready(function() {

		var select = document.getElementById("bufferpool4k");
		var options = new Array(50);
		for(var i =0; i < options.length; i++){
			options[i] = i;
		}
		var opt = null;
		var el = null;
		for (var i = 0; i < options.length; i++) {
			opt = "BP"+options[i];
			el  = document.createElement("option");
			el.textContent = opt;
			el.value = opt;
			select.appendChild(el);
		}
		$(select).val("BP0");
		
		select = document.getElementById("bufferpool8k");
		options = new Array(10);
		for(i =0; i < options.length; i++){
			options[i] = i;
		}
		opt = null;
		el = null;
		for (i = 0; i < options.length; i++) {
			opt = "BP8K"+options[i];
			el  = document.createElement("option");
			el.textContent = opt;
			el.value = opt;
			select.appendChild(el);
		}  
		$(select).val("BP8K0");

		select = document.getElementById("bufferpool16k");
		opt = null;
		el = null;
		for (i = 0; i < options.length; i++) {
			opt = "BP16K"+options[i];
			el  = document.createElement("option");
			el.textContent = opt;
			el.value = opt;
			select.appendChild(el);
		}  
		$(select).val("BP16K0");

		select = document.getElementById("bufferpool32k");
		opt = null;
		el = null;
		for (i = 0; i < options.length; i++) {
			if (i === 0) {
				opt = "BP32K";
			} else {
				opt = "BP32K"+options[i];
			}
			el  = document.createElement("option");
			el.textContent = opt;
			el.value = opt;
			select.appendChild(el);
		}  
		$(select).val("BP32K");
		
		$.validator.addMethod("stoGroup", function(value, element){
			var type = $('#dbmsType').val();
			
			if (type === db2zos) {					
				return (/^[a-zA-Z@#$][a-zA-Z0-9@#$]{0,7}$/.test(value));
			} 
		}, badStoGroup );
		
		$.validator.addMethod("validBufferPool", function(value, element){
			var type = $('#dbmsType').val();
			
			if (type === db2zos) {
				return value !== "";
			} 
		}, invalidBufferpool );
		
		var isDB2zOS = function(element) {
			return $('#dbmsType').val() === db2zos;
		};
	
		bufferPoolsValidator = $('#bufferPoolsForm').validate({
			rules: {
				databaseStoGroup: {
					required: {
						depends: isDB2zOS
					},
					stoGroup: true
				},
				bufferpool4k: {
					required: {
						depends: isDB2zOS
					},
					validBufferPool : true
				},
				bufferpool8k: {
					required: {
						depends: isDB2zOS
					},
					validBufferPool : true
				},
				bufferpool16k: {
					required: {
						depends: isDB2zOS
					},
					validBufferPool : true
				},
				bufferpool32k: {
					required: {
						depends: isDB2zOS
					},
					validBufferPool : true
				}
			},
	        errorPlacement: function (error, element) {
	            $(element).removeClass("valid");
	            $(element).addClass("errorborder");
	            var message = error.html();
	            
	            if (message && message.length > 0) {
	            	$('#db-ok-button').attr('disabled', 'disabled');
	            }
	        	
	        },
	        success : function(success, element) {
	        	$('#db-ok-button').prop('disabled', false);
	            $(element).removeClass('errorborder');
	            
	            if (bufferPoolsValidator.numberOfInvalids() === 0) {
	                $.clearStatus();
	            }
	        },
	        onfocusin : function(element, event) {
	        	bufferPoolsValidator.element(element);
	        },
	        onkeyup : function(element, event) {
	        	if (event.which !== 9) {
	        		bufferPoolsValidator.element(element);
	        	}
	        }
		});
		
	});
	
})(jQuery);
